import React from 'react';
import PropTypes from 'prop-types';

class DashboardUserDetails extends React.Component {
	constructor(props) {
		super(props);

		this.mapPhoneNumber = this.mapPhoneNumber.bind(this);
	}

	mapPhoneNumber(n) {
		if(!n)
			return null
		else if(n.length === 11)
			return `${n[0]}-${n.slice(1,4)}-${n.slice(4,7)}-${n.slice(7)}`
		else if(n.length === 10)
			return `${n.slice(0,3)}-${n.slice(3,6)}-${n.slice(6)}`
		else if(n.length === 7)
			return `${n.slice(0,3)}-${n.slice(3)}`
		else
			return n
	}

	render() {
		let {
			personal_phone, work_phone, email, address, users_in_account, account_user_limit
		} = this.props.user;

		return (
			<div className='dashboard-user-details-container'>
				<ul className="list-unstyled">
					{(() => {
						if(personal_phone && work_phone) {
							return (
								<div>
									<li>
										<i className="fa fa-phone" /> <span className="text-weight-bold">Personal Phone: </span>
										{this.mapPhoneNumber(personal_phone)}
									</li>
									<li><i className="fa fa-phone"></i> <span className="text-weight-bold">Work Phone: </span>
										{this.mapPhoneNumber(work_phone)}
									</li>
								</div>
							)
						}
						else if(personal_phone || work_phone) {
							return (
				        <li>
				        	<i className="fa fa-phone" />
				        		<span className="text-weight-bold">Phone: </span>
				        		{this.mapPhoneNumber(personal_phone) || this.mapPhoneNumber(work_phone)}
				        </li>
							)
						}
					})()}
	        {email ? <li><i className="fa fa-inbox" /> <span className="text-weight-bold">Email: </span> {email || 'No Email'} </li> : ''}
	        {address.street ? <li><i className="fa fa-home" /> <span className="text-weight-bold">Address:</span> {address.street || ''}</li> : ''}
	        <li>
	          {address.city || address.state || address.zip ? <ul className="list-inline">
	            <li><i className="fa fa-globe"></i> {address.city ? <span><span className="text-weight-bold">City: </span> {address.city}</span> : ''} </li>
	            {address.state ? <li><span className="text-weight-bold">State: </span> {address.state || ''}</li> : ''}
	            {address.zip ? <li><span className="text-weight-bold">Zip: </span> {address.zip || ''}</li> : ''}
	          </ul> : ''}
	        </li>
	        {(() => {
	        	if(this.props.user.role === 'Client Admin' && users_in_account !== undefined && account_user_limit !== undefined) {
	        		return (
	        			<li>
	        				<i className="fa fa-user-circle-o" />
	        				<span className="text-weight-bold"> Users In Account: </span>
	        				{`${users_in_account}/${account_user_limit}`}
	        			</li>
	        			)
	        	}
	        })()}
	      </ul>
			</div>
		)
	}
}

export default DashboardUserDetails;



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/dashboardUserDetails.js